import { memo } from 'react';
import { EdgeProps } from '@xyflow/react';

export const SimpleEdge = memo(({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style,
}: EdgeProps) => {
  const path = `M ${sourceX} ${sourceY} L ${targetX} ${targetY}`;

  return (
    <path
      id={id}
      className="react-flow__edge-path"
      d={path}
      style={{
        ...style,
        fill: 'none',
        stroke: 'hsl(var(--muted-foreground))',
        strokeWidth: 2,
        opacity: 0.5,
      }}
    />
  );
});

SimpleEdge.displayName = 'SimpleEdge';
